export const FETCH_DIRECTIONS_START = 'DIRECTIONS/FETCH_DIRECTIONS_START';
export const FETCH_DIRECTIONS_SUCCESS = 'DIRECTIONS/FETCH_DIRECTIONS_SUCCESS';
export const FETCH_DIRECTIONS_FAILURE = 'DIRECTIONS/FETCH_DIRECTIONS_FAILURE';
export const SET_DIRECTIONS = 'DIRECTIONS/SET_DIRECTIONS';
export const SET_SPECIALIZATION = 'DIRECTIONS/SET_SPECIALIZATION';
export const SET_DIRECTION = 'DIRECTIONS/SET_DIRECTION';
export const RESET = 'DIRECTIONS/RESET';
